import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-anlegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAnlegenEffects {

    VeranstaltungAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_ANLEGEN),
        mergeMap((x: ac.PostVeranstaltungAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungAnlegen(x.veranstaltungAnlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungAnlegenErfolgreichAction(result, x.veranstaltungAnlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungAnlegenFehlerAction(error, x.veranstaltungAnlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
